const PropTypes = require('prop-types')

// window.Element is only available in web browsers
const Element = typeof window !== 'undefined'
? window.Element
: function () {}

module.exports = {
  /** @see https://stackoverflow.com/a/51127130 */
  domRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.instanceOf(Element)
    })
  ])
}
